import script from "./user-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-panel.vue?vue&type=script&setup=true&lang=ts"

import "./user-panel.vue?vue&type=style&index=0&id=6c542447&lang=scss"

const __exports__ = script;

export default __exports__